import { getAsyncJob } from './api';

const DEFAULT_INTERVAL_MS = 3000;
const DEFAULT_TIMEOUT_MS = 5 * 60 * 1000;

export type AsyncJob = {
    jobId: string;
    status?: string;
    ready?: boolean;
    result?: { status?: string; [key: string]: any } | null;
    error?: string | null;
};

/**
 * Poll ``GET /api/v1/job/:id`` until the job reaches a terminal state
 * (``ready``), the timeout elapses, or a request fails. Resolves with the
 * final job payload (``ready`` may be false if it timed out).
 *
 * Used to follow the async PR-conflict auto-resolution job that the backend
 * kicks off when a finished work's solution has merge conflicts.
 */
export async function pollAsyncJob(
    jobId: string,
    {
        intervalMs = DEFAULT_INTERVAL_MS,
        timeoutMs = DEFAULT_TIMEOUT_MS
    }: { intervalMs?: number; timeoutMs?: number } = {}
): Promise<AsyncJob> {
    const deadline = Date.now() + timeoutMs;

    // eslint-disable-next-line no-constant-condition
    while (true) {
        const job = (await getAsyncJob(jobId)) as AsyncJob;
        if (job?.ready || Date.now() >= deadline) {
            return job;
        }
        await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }
}
